import React from 'react';
import { useDispatch } from 'react-redux';
import { useIsMutating } from 'react-query';
import CancelToDetails from '../../../../controllers/CancelToDetails';
import { actionCreators, sliceKeys } from '../../../../model';

const { changeDesksSettingsPageReset } =
  actionCreators[sliceKeys.changeDesksSettingsPage];

const CancelChanges = () => {
  const dispatch = useDispatch();

  const mutationCount = useIsMutating();

  const resetFn = () => dispatch(changeDesksSettingsPageReset());

  return <CancelToDetails resetFn={resetFn} disabled={mutationCount > 0} />;
};

export default CancelChanges;
